import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts';
import { CHART_COLORS, formatCompact } from '../homeConfig';

const TooltipBox = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-slate-200 shadow-md p-3 rounded-lg">
      <p className="text-xs font-semibold text-slate-700 mb-1">{label} days</p>
      <p className="text-sm text-orange-600 font-medium">{formatCompact(payload[0].value)}</p>
    </div>
  );
};

const ARAgingBars = ({ data }) => (
  <ResponsiveContainer width="100%" height={260}>
    <BarChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
      <XAxis dataKey="bucket" tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} />
      <YAxis tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} tickFormatter={formatCompact} width={56} />
      <Tooltip content={<TooltipBox />} cursor={{ fill: 'rgba(234,88,12,0.06)' }} />
      <Bar dataKey="amount" radius={[4, 4, 0, 0]} maxBarSize={48}>
        {data.map((entry, i) => (<Cell key={entry.bucket} fill={CHART_COLORS.aging[i % CHART_COLORS.aging.length]} />))}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);

export default ARAgingBars;
